import { Divider } from '@mui/material';
import { useState } from 'react';
import { LayerHead, timeAnim } from './layerHead';
import { HidroLayer, HidroLayerGroup } from './layers';

interface Props {
  hidroLayer: HidroLayer | HidroLayerGroup;
  maxWidth?: string | number;
  width?: string | number;
}
export const HidroLayerComponent: React.FC<Props> = (data) => {
  const { hidroLayer, maxWidth, width } = data;

  const component = (layer: HidroLayerGroup | HidroLayer) => {
    if (layer instanceof HidroLayerGroup) return <TroggleLayer
      layer={layer}
      initialOpen={false}
      maxWidth={maxWidth}
      width={width}
    />;
    return <LayerHead
      layer={layer}
      maxWidth={maxWidth}
      width={width}
    />;
  };

  return component(hidroLayer);
};


interface PropsTroggle {
  initialOpen: boolean;
  layer: HidroLayerGroup;
  maxWidth?: string | number;
  width?: string | number;
}
const TroggleLayer: React.FC<PropsTroggle> = (data) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleBox = () => setIsOpen(!isOpen);

  return <div style={{
    maxWidth: data.maxWidth,
    width: data.width,
    backgroundColor: "transparent"
  }}>
    <LayerHead
      layer={data.layer}
      expand={isOpen}
      onExpand={toggleBox}
    />

    <div style={{
      paddingLeft: !isOpen ? 0 : '15px',
      maxHeight: !isOpen ? 0 : "101%",
      transition: `max-height ${timeAnim}s ease-out`,
      overflowY: "hidden",
    }}>
      {isOpen && data.layer.layers.map((layer, index) => {
        if (layer instanceof HidroLayer) return <LayerHead key={index} layer={layer} maxWidth={data.maxWidth} />;
        return <TroggleLayer key={index} layer={layer} initialOpen={false} maxWidth={data.maxWidth} />;
      })}
    </div>

    {isOpen && <Divider sx={{ marginY: "2px", marginX: "5px" }} />}

  </div>;
};